export default {
  getters: {
    operations(state) {
      return state.operations;
    },
  },
};
